<template>
  <section class="form" :class="{ create: create }" @click="handleClick">
    <template v-if="create">
      <div class="info">
        <PlusOutlined class="icon" />
        <span>Crear nuevo formulario</span>
      </div>
    </template>

    <template v-else>
      <div class="form__menu">
        <a-tooltip title="Editar">
          <a-button class="button" type="link">
            <EditOutlined class="form__icon" @click="handleEdit" />
          </a-button>
        </a-tooltip>

        <a-tooltip title="Eliminar">
          <a-button class="button" type="link">
            <DeleteOutlined class="form__icon" @click="handleDelete" />
          </a-button>
        </a-tooltip>
      </div>

      <!-- <p class="form__title">Formulario tipo</p> -->

      <h4 class="form__name">{{ name }}</h4>

      <p class="form__description">
        {{ description }}
      </p>

      <p class="total-typifications">Vinculado {{ count === 1 ? `1 vez` : `${count} veces` }}</p>
    </template>
  </section>
</template>

<script>
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";

export default {
  components: {
    DeleteOutlined,
    PlusOutlined,
    EditOutlined,
  },

  props: {
    id: Number,
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    create: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const router = useRouter();

    const handleDelete = () => {
      emit("delete");
    };

    const handleClick = () => {
      if (!props.create) return;

      emit("create");
    };

    const handleEdit = () => {
      router.push(`forms/${props.id}`);
    };

    return {
      handleDelete,
      handleClick,
      handleEdit,
    };
  },
};
</script>

<style lang="sass" scoped>
.button
  padding: 0
  height: 22px

.form
  height: 194px
  background: $gray-2
  border-radius: 4px
  border: $border-medium
  position: relative

  &.create
    display: flex
    align-items: center
    justify-content: center
    border-color: $blue-6
    color: $blue-6
    border-style: dashed
    background-color: $blue-1
    cursor: pointer

    // &:hover
    //   filter: brightness(1.02)

    .info
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center

      .icon
        font-size: 32px
        margin-bottom: 8px

  &__menu
    display: flex
    justify-content: flex-end
    gap: 6px
    padding: 6px 10px 0px
    margin-bottom: 5px

  &__title
    color: $gray-6
    font-size: $font-small
    text-align: center
    margin-bottom: 2px

  &__name
    text-align: center
    color: $gray-9

  &__description
    color: $gray-8
    font-size: $font-small
    padding: 0 16px
    text-align: center
    word-wrap: break-word

.total-typifications
    color: $gray-6
    font-size: $font-small
    position: absolute
    bottom: 0
    right: 0
    left: 0
    padding: 0 10px
    text-align: center
    font-style: italic
    line-height: 8px
</style>
